@if (enableLink) {
  @if (openInNewWindow) {
    <a [href]="url" target="_blank" rel="noopener noreferrer">
      {{ linkText }}
    </a>
  } @else {
    <a [attr.href]="url || null" (click)="onLinkClick($event)">
      {{ linkText }}
    </a>
  }
}

@if (!enableLink) {
  {{ linkText }}
}
